import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Font16 } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'
import InputControl from 'components/Input/InputControl'
import { ClaimDeviceH4 } from '../styles'

export const ClaimDeviceBlocksContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 58px;
  position: relative;
  @media ${theme.devices.tablet} {
    flex-direction: row;
    justify-content: space-around;
    gap: 0;
  }
`

export const ClaimDeviceBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  @media ${theme.devices.tablet} {
    width: 50%;
    min-height: 572px;
    &:last-child {
      border-left: 1px solid rgba(0, 0, 0, 0.05);
    }
  }
`

export const ClaimDeviceIcon = styled.img`
  width: 100px;
  height: 100px;
  margin-bottom: 20px;
`

export const ClaimDeviceLabel = styled.div`
  ${Font16};
  font-weight: 900;
  margin-bottom: 20px;
`

export const ClaimDeviceInputControl = styled(InputControl)`
  min-width: 320px;
  margin-bottom: 26px;
`

export const ClaimDeviceAppNameLabel = styled(ClaimDeviceH4)`
  margin-bottom: 48px;
`

export const ClaimDeviceIconDelete = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const ClaimDeviceDeleteButton = styled(CommonLinkButton)`
  position: absolute;
  right: 5px;
  top: -34px;
  padding: 4px 0 0;
`
